module.exports = __webpack_public_path__ + "img/SunleiGraduate.79f8c16c.png";